<script lang="ts">
  import { _ } from 'svelte-i18n';
  
  export let isOpen = false;
  export let title: string;
  export let message: string;
  export let confirmLabel: string = null;
  export let cancelLabel: string = null;
  export let onConfirm: () => void;
  export let onCancel: () => void;
  export let doubleConfirm: boolean = false;
  
  let randomNumber: number = 0;
  let userInput: string = '';
  let isConfirmEnabled: boolean = true;
  
  // Generate random number when doubleConfirm is true and modal opens
  $: if (isOpen && doubleConfirm) {
    randomNumber = Math.floor(Math.random() * 90) + 10; // Random number between 10-99
    userInput = '';
    isConfirmEnabled = false;
  }
  
  // Check if user input matches random number
  $: if (doubleConfirm) {
    isConfirmEnabled = Number(userInput) === randomNumber;
  }
</script>


{#if isOpen}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <dialog open>
    <article>
      <header>
        <h3>{title}</h3>
        <button aria-label="Close" class="close" on:click={onCancel}></button>
      </header>
      <p>{message}</p>

      {#if doubleConfirm}
        <div class="double-confirm-section">
          <p>{$_('confirmation_modal.double_confirm_message', { values: { number: randomNumber } })}</p>
          <input 
            type="number" 
            bind:value={userInput}
            placeholder={$_('confirmation_modal.double_confirm_placeholder')}
            class="confirmation-input"
          />
        </div>
      {/if}

      <footer class="flex space-between">
        <button type="button" class="secondary" on:click={onCancel}>
        {cancelLabel || $_('common.cancel')}
        </button>
        <button type="button" on:click={onConfirm} disabled={!isConfirmEnabled}>
          {confirmLabel || $_('common.delete')}
        </button>
      </footer>
    </article>
  </dialog>
{/if}


<style>
  dialog {
    z-index: 1001;
  }
  
  
  .confirmation-input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
    text-align: center;
  }
  
  .confirmation-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
  
  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  </style>